import { render } from "./WhySection.vue?vue&type=template&id=8a12add4&scoped=true"
import script from "./WhySection.vue?vue&type=script&lang=js"
export * from "./WhySection.vue?vue&type=script&lang=js"

import "./WhySection.vue?vue&type=style&index=0&id=8a12add4&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a12add4"]])

export default __exports__